/**
 * @file normalizeComicListItem.js
 * @description 统一搜索/分类列表项字段（comicThemeVo → comicThemeArray）
 */

/**
 * @typedef {Object} ComicListItemType
 * @property {string} id
 * @property {string} cover
 * @property {string} name
 * @property {string} [authorName]
 * @property {string} [synop]
 * @property {Array<{ themeCode: number|string, themeName: string }>} comicThemeArray
 * @property {number|string} [serialStatus]
 * @property {string} [serial]
 * @property {number} [volTotal]
 */

/**
 * 将接口列表项归一化为模板可用结构
 * @param {Record<string, unknown>|null|undefined} item
 * @returns {ComicListItemType|null}
 */
export function normalizeComicListItem(item) {
  if (!item || item.id == null) return null

  const themes =
    item.comicThemeVo ??
    item.comicThemeArray ??
    item.themeArray ??
    item.themes ??
    []

  return {
    ...item,
    id: String(item.id),
    comicThemeArray: Array.isArray(themes) ? themes : [],
  }
}

/**
 * @param {Array<Record<string, unknown>>|null|undefined} items
 * @returns {ComicListItemType[]}
 */
export function normalizeComicListItems(items) {
  if (!Array.isArray(items)) return []
  return items.map(normalizeComicListItem).filter(Boolean)
}
